export const enum NotificationTypeEnum {
    ChatMessage,
    Email,
}
